/**
 *  Global configuration
 */
import Package from "../package.json";

export const Config = {
  Version: Package.version,
};
